import React, { lazy } from "react";

// MUI Icons
import EventIcon from "@mui/icons-material/Event";
import SearchIcon from "@mui/icons-material/Search";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import Groups3Icon from "@mui/icons-material/Groups3";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import SchoolIcon from "@mui/icons-material/School";
import HistoryEduIcon from "@mui/icons-material/HistoryEdu";
import CastForEducationIcon from "@mui/icons-material/CastForEducation";
import FilterFramesIcon from "@mui/icons-material/FilterFrames";
import SubjectIcon from "@mui/icons-material/Subject";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import SupervisedUserCircleIcon from "@mui/icons-material/SupervisedUserCircle";
import LanguageIcon from "@mui/icons-material/Language";
import DiscountIcon from "@mui/icons-material/Discount";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import HelpIcon from "@mui/icons-material/Help";
import HubIcon from "@mui/icons-material/Hub";
import UpcomingIcon from "@mui/icons-material/Upcoming";
import SummarizeIcon from "@mui/icons-material/Summarize";
import QuizIcon from "@mui/icons-material/Quiz";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import PlaylistAddCheckCircleIcon from "@mui/icons-material/PlaylistAddCheckCircle";
import SettingsAccessibilityIcon from "@mui/icons-material/SettingsAccessibility";
import AssessmentIcon from "@mui/icons-material/Assessment";
import IPAccessIcon from "@mui/icons-material/AcUnitOutlined";
import FolderCopyIcon from '@mui/icons-material/FolderCopy';
import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";
import FolderList from "pages/FolderManagement/FolderList";
import Dashboard from "pages/Dashboard/Dashboard";
const ChangePassword = lazy(() =>
  import("pages/ChangePassword/ChangePassword")
);


export const sidebar = (roles = []) => {
  const sidebarData = [
    // {
    //   id: 100000,
    //   enabled: roles.includes(100000),
    //   name: "Dashboard",
    //   icon: <DashboardIcon fontSize="small" />,
    //   path: "/dashboard",
    //   isChild: null,
    // },

    //************************************************** Folder Management *************************************************** */ 
    {
      id: 400000,
      enabled: roles.includes(400000),
      name: "Folder Management",
      icon: <FolderCopyIcon fontSize="small" />,
      path: "/folder-management",
      isChild: null,
    }
  ].filter((side) => side.enabled);

  return sidebarData;
};

export const routes = (roles = []) => {
  const routesData = [
    // {
    //   id: 100000,
    //   enabled: roles.includes(100000),
    //   element: <Dashboard />,
    //   path: "/dashboard",
    // },

    // ******************************* Folder Management ***************************************
    {
      id: 400000,
      enabled: roles.includes(400000),
      element: <FolderList />,
      path: "/folder-management",
    },
    {
      enabled: true,
      element: <ChangePassword />,
      path: "/change-password",
    },

  ].filter((route) => route.enabled);
  return routesData;
};
